import { useState } from "react";
import { db } from "../firebase/config";
import { collection, addDoc } from "firebase/firestore";
import "../styles/kpi-form.css";
import toast, { Toaster } from "react-hot-toast";
import { useTheme } from "@mui/material/styles";

export default function KpiForm({ perusahaan, tahun, onSuccess }) {
  const [formData, setFormData] = useState({
    indikator: "",
    keterangan: "",
    satuan: "",
    bobot: "",
    target: "",
    target_sd_sekarang: "-",
    realisasi: "-",
    pencapaian: "-",
    nilai: "-",
    uploadEvidence: "-",
  });

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(
        collection(db, "kpi_collections", perusahaan, tahun),
        formData
      );
      onSuccess(); // Panggil callback setelah berhasil simpan
      setFormData({
        indikator: "",
        keterangan: "",
        satuan: "",
        bobot: "",
        target: "",
        target_sd_sekarang: "-",
        realisasi: "-",
        pencapaian: "-",
        nilai: "-",
        uploadEvidence: "-",
      });
      toast.success("Data KPI Berhasil ditambah");
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Group fields into two columns
  const leftColumnFields = [
    "indikator",
    "keterangan",
    "satuan",
    "bobot",
    "target",
  ];

  const rightColumnFields = [
    "target_sd_sekarang",
    "realisasi",
    "pencapaian",
    "nilai",
    "uploadEvidence",
  ];

  const formatLabel = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const renderField = (key) => (
    <div key={key} className="form-group">
      <label htmlFor={key}>{formatLabel(key)}</label>
      {key === "keterangan" ? (
        <textarea
          id={key}
          name={key}
          rows="3"
          value={formData[key]}
          onChange={handleChange}
          className="form-control"
          required
        />
      ) : (
        <input
          type={key === "bobot" || key === "target" ? "number" : "text"}
          id={key}
          name={key}
          value={formData[key]}
          onChange={handleChange}
          className="form-control"
          required={!["-"].includes(formData[key])}
        />
      )}
    </div>
  );

  return (
    <form
      className={`modern-kpi-form ${isDarkMode ? "dark-mode" : "light-mode"}`}
      onSubmit={handleSubmit}
    >
      <h2 className="form-title">Tambah KPI Baru</h2>
      <div className="form-columns">
        <div className="form-column">{leftColumnFields.map(renderField)}</div>
        <div className="form-column">{rightColumnFields.map(renderField)}</div>
      </div>
      <button type="submit" className="submit-btn">
        Simpan Data KPI
      </button>
      <Toaster position="top-right" reverseOrder={false} />
    </form>
  );
}
